import { gql, useQuery } from '@apollo/client';
import { SignUpRangeValue } from '../../../shared/types';
import { RiderGender, RiderSigningMethod } from '../Components/RidersFilter';

const gqlQueryFilter = gql`
    query overviewRiderState {
        CITRIN_MGT_overviewRiderState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewRiderState';

export type OverviewState = {
    search?: string;
    gender?: RiderGender;
    signingMethod?: RiderSigningMethod;
    identityCheck?: 'All' | true | false;
    selectedDateRange?: SignUpRangeValue;
    page?: number;
    pageSize?: number;
    timestamp?: string;
};

const initialState: OverviewState = {
    search: '',
    gender: 'All',
    signingMethod: 'All',
    identityCheck: 'All',
    selectedDateRange: {
        fromDate: undefined,
        toDate: undefined,
    },
    page: 1,
    pageSize: 10,
    timestamp: new Date().toString(),
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewRiderState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewRiderState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewRiderState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewRiderState',
                },
            },
        },
    ],
};
